<template>
  <div>
    <div>
      <img
        class="backImg"
        :src="
          language === 'zh'
            ? require('@/assets/images/companyProfile/backgroundImg.jpg')
            : require('@/assets/images/companyProfile/en_backgroundImg.jpg')
        "
      />
    </div>
    <div class="bread">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="21" :md="16">
          <slot name="breadcrumb"></slot>
        </el-col>
      </el-row>
    </div>

    <div class="container">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="21" :md="16">
          <div class="contentBox">
            <div class="name">{{ form.name }}</div>
            <div class="info">
              <el-row :gutter="100">
                <el-col :xs="24" :sm="8" :md="8">
                  <div>
                    <i class="el-icon-set-up"></i
                    ><span class="info-title"
                      >{{
                        $t("contactUs.recruitmentTable.recruitmentCategory")
                      }}：</span
                    >{{ form.job_type_name }}
                  </div>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8">
                  <div>
                    <i class="el-icon-house"></i
                    ><span class="info-title"
                      >{{ $t("contactUs.recruitmentTable.department") }}：</span
                    >{{ form.department_name }}
                  </div>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8">
                  <div>
                    <i class="el-icon-time"></i
                    ><span class="info-title"
                      >{{
                        $t("contactUs.recruitmentTable.releaseTime")
                      }}：</span
                    >{{ form.add_time }}
                  </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24">
                  <div class="address">
                    <i class="el-icon-location-outline"></i
                    ><span class="info-title"
                      >{{
                        $t("contactUs.recruitmentTable.workingLocation")
                      }}：</span
                    >{{ form.work_place_name }}
                  </div>
                </el-col>
              </el-row>
              <!-- <div v-html="form.remark"></div> -->
            </div>
            <!-- <div class="content">
              <div v-html="form.content"></div>
            </div> -->
            <div class="title">
              {{ $t("contactUs.recruitmentTable.jobDescription") }}：
            </div>
            <div class="content">
              <span>{{ form.responsibility }}</span>
            </div>
            <div class="title">
              {{ $t("contactUs.recruitmentTable.qualification") }}：
            </div>
            <div class="content">
              <span>{{ form.content }}</span>
            </div>
            <el-divider></el-divider>
            <div class="title">
              {{ $t("contactUs.recruitmentTable.HRContactInformation") }}：
            </div>
            <div class="content">
              <span>{{ form.hr_linktel }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { recruitRead } from "@/api/contactUs";
import { formatTimeNum } from "@/utils/index";
import { localStorage } from "../../utils/storage";
export default {
  data() {
    return {
      language: localStorage.get("language") || "zh",
      form: {},
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      recruitRead({ id: this.$route.query.id })
        .then((res) => {
          if (res.code === 0) {
            res.data.add_time = formatTimeNum(res.data.add_time, "Y-M-D");
            this.form = res.data;
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped>
.backImg {
  width: 100%;
  /* height: 300px; */
}
.bread {
  background-color: #f6f6f6;
  padding: 15px 20px;
}
.container {
  padding: 30px 20px;
}
.name {
  text-align: center;
  font-size: 24px;
  font-weight: 800;
  color: #32589f;
}
.info {
  margin-top: 20px;
  /* display: flex;
  flex-wrap: wrap;
  justify-content: space-around; */
  background-color: rgba(247, 247, 247, 1);
  padding: 20px;
  font-size: 15px;
  color: #333333;
}
.info-title {
  font-size: 14px;
  color: #777777;
}
.address {
  margin-top: 20px;
}
.title {
  font-size: 17px;
  font-weight: 800;
  color: #32589f;
  margin: 20px 0 10px 0;
}
.content {
  padding-bottom: 5px;
  font-size: 14px;
  white-space: pre-line;
  color: rgba(51, 51, 51, 0.838);
}
.content > span {
  line-height: 35px;
}
@media only screen and (max-width: 768px) {
  .backImg {
    width: 100%;
    height: auto;
  }
  .name {
    font-size: 21px;
  }
  .info {
    padding: 10px;
    margin-top: 10px;
    font-size: 14px;
  }
  .info > div {
    /* width: 50%; */
    line-height: 35px;
  }
  .address {
    margin-top: 0;
  }
}
</style>